'use client';

import { Suspense } from 'react';
import RoleLoginContent from '@/components/auth/RoleLoginContent';

export default function MerchantLoginPage() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-background flex items-center justify-center"><div className="text-muted-foreground text-sm">Loading...</div></div>}>
      <RoleLoginContent
        role="merchant"
        roleLabel="Merchant"
        redirectPath="/merchant-portal"
        accentColor="violet"
        description="WorldwayLuxe Merchant Portal — merchant and reseller access"
        features={[
          { icon: '⬡', label: 'Commission Dashboard', desc: 'Track earnings, commissions, and payouts' },
          { icon: '◈', label: 'Booking Management', desc: 'Manage bookings made through your channel' },
          { icon: '✦', label: 'Performance Analytics', desc: 'Revenue trends and conversion insights' },
        ]}
      />
    </Suspense>
  );
}
